export { };

declare global {
    interface Date {
        toDateOnly(): string;
    }
}

Date.prototype.toDateOnly = function () {
    let date = this;
    return `${date.getFullYear()}-${`00${date.getMonth() + 1}`.slice(-2)}-${`00${date.getDate()}`.slice(-2)}`
}